import { PoolShape } from "../constants/pool";

export interface PoolInfo {
  shape: PoolShape;
  depth: number;
  type: ItemType | null;
  country: string;
  state: string;
  city: string;
  postcode: string;
  location: PoolLocation | null;
  lowTemp: number;
  electricityCost: number | null;
  withCover: boolean | null;
  operatingHours: number;
  requirePoolTemp: number;
  poolType: PoolType | null;
  poolMaterial: PoolMaterial | null;
  diameter: number;
  length: number;
  width: number;
  surfaceArea: number;
}

export enum PoolMaterial {
  CONCRETE = "Concrete/Ceramic",
  PLASTICLINER = "Plastic Liner",
  FIBERGLASS = "Fibre glass",
}

export const poolMaterialFactor = {
  [PoolMaterial.CONCRETE]: 1,
  [PoolMaterial.FIBERGLASS]: 0.5,
  [PoolMaterial.PLASTICLINER]: 0.25,
};

export enum ItemType {
  Pool = "Pool",
  Spa = "Spa",
}

export enum PoolType {
  Inground = "Inground",
  Aboveground = "Aboveground",
}

export enum PoolLocation {
  INDOOR = "Indoor",
  OUTDOOR = "Outdoor",
}

export const PoolTypes = Object.values(ItemType);
export const PoolLocations = Object.values(PoolLocation);
export const PoolMaterials = Object.values(PoolMaterial);

export interface HeatData {
  heatDemandLoss: number[];
  heatSurfaceLoss: number[];
  maxHeatLoss?: number;
}

export interface ModelData {
  totalCost: number;
  model: number[] | undefined[] | undefined | any;
  costArr: number[] | undefined[] | undefined | any;
  inputArr: number[] | undefined[] | undefined | any;
  status: string | any;
  modelInputKwPower: number | any;
  requireApprox: number | any;
  minHeatOutput: number | any;
}

interface Colour {
  fillColor: string;
  strokeColor: string;
}

interface ChartOptions {
  scaleOverride?: boolean;
  scaleSteps?: number;
  scaleStepWidth?: number;
  scaleStartValue?: number;
}

interface ChartDataset {
  withoutCoverVal: number;
  withCoverVal: number;
  month: string;
  [key: string]: string | number | Date | null | undefined;
}
export interface ChartData {
  labels: string[];
  series: string[];
  data: ChartDataset[];
  colours: Colour[];
  options: ChartOptions;
}

export type MonthsCheckbox = {
  jan: boolean;
  feb: boolean;
  mar: boolean;
  apr: boolean;
  may: boolean;
  jun: boolean;
  jul: boolean;
  aug: boolean;
  sep: boolean;
  oct: boolean;
  nov: boolean;
  dec: boolean;
};

export interface PoolContextData {
  poolInfo: PoolInfo;
  heatData: HeatData;
  degreesPower: {
    small: number;
    big: number;
  };
  chartData: ChartData | null;
  setPoolInfo: React.Dispatch<React.SetStateAction<PoolInfo>>;
  setChartData: React.Dispatch<React.SetStateAction<ChartData | null>>;
  temperaturePerMonth: WeatherTemperatureAvaragePerMonth;
  measures: {
    surfaceAreaTop: number;
    estimateVol: number;
  };
  pricesData: {
    premiumPricePerMonth: number[];
    standartPricePerMonth: number[];
    bigConsumption: number[];
    smallConsumption: number[];
    totalPremiumPrice: number;
    totalStandartPrice: number;
  };
  pumpCapacity: {
    standart: number;
    premium: number;
    counter: number;
  };
}

export interface UserContextData {
  user: string;
  setUser: React.Dispatch<React.SetStateAction<string>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  latestRecoomendationReportId: string | null;
  setLatestRecoomendationReportId: React.Dispatch<React.SetStateAction<string>>;
  isExistingPool: boolean | null;
  setIsExistingPool: React.Dispatch<React.SetStateAction<boolean | null>>;
}

export interface StepContextData {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

export interface SeasonMonth {
  index: number;
  name: string;
  value: boolean;
}

export enum SeasonTypes {
  Full = "Full",
  Extended = "Extended",
  Summer = "Summer",
  Custom = "Custom",
}
export interface SeasonContextData {
  months: {
    jan: SeasonMonth;
    feb: SeasonMonth;
    mar: SeasonMonth;
    apr: SeasonMonth;
    may: SeasonMonth;
    jun: SeasonMonth;
    jul: SeasonMonth;
    aug: SeasonMonth;
    sep: SeasonMonth;
    oct: SeasonMonth;
    nov: SeasonMonth;
    dec: SeasonMonth;
  };
  setMonths: React.Dispatch<React.SetStateAction<any>>;
  season: SeasonTypes;
  setSeason: React.Dispatch<React.SetStateAction<SeasonTypes>>;
}

export interface WeatherTemperatureAvaragePerMonth {
  [key: number]: number;
}
